module.exports = __webpack_public_path__ + "static/media/Graduation-pana.1351e3b3.png";